import { NgModule } from '@angular/core';

import { ReCaptchaV3Service } from './recaptcha-v3.service';

@NgModule({
  providers: [
    ReCaptchaV3Service,
  ],
})
export class RecaptchaV3Module {
}
